import { getNext, canDeriveMediaFromStops } from 'aria-viewer/utils/functions'
import { internalGetMainMedia } from 'aria-viewer/media/mediaTransformer'
import { FRONT } from 'aria-viewer/navigation/navigationActions'
import { MEDIA_TYPES } from 'aria-viewer/tour/constants/index'
import { PanoPlayer, WTPhotoController } from '../legacy'
const CACHE = {}

export const updateImageCache = (stopsList, currentStopIndex) => (dispatch, getState) => {
    const state = getState()
    const trailsList = state.getIn(['tour', 'trails', 'list'])
    const trailsCache = state.getIn(['tour', 'trails', 'cache'])
    const stopsCache = state.getIn(['tour', 'stops', 'cache'])
    const pointsCache = state.getIn(['tour', 'points', 'list'])
    const trails = Object.keys(trailsCache)
        .reduce((trails, key) => [...trails, ...trailsCache[key]], [])
        .reduce((trails, trail) => Object.assign({}, { [trail.trailid]: trail }, trails), {})
    const stops = Object.keys(stopsCache)
        .reduce((stops, key) => [...stops, ...stopsCache[key]], [])
        .reduce((stops, stop) => Object.assign({}, { [stop.stopid]: stop }, stops), {})
    const currentPanoramaParams = state.getIn(['tour', 'currentPanoramaParams'])

    // Get the next three steps
    //
    //

    let cloneTour = state.get('tour').asMutable()
    let next3 = []
    for (let i = 0; i < 3; i++) {
        const next = getNext(cloneTour)
        cloneTour = cloneTour.mergeIn(['trails', 'current'], next.trails_current)
        cloneTour = cloneTour.mergeIn(['points', 'current'], next.points_current)
        let point =
            pointsCache[trailsList[cloneTour.get('trails').get('current')].id][cloneTour.get('points').get('current')]
        next3.push(point)
    }

    // Get steps from next trail connections if we are standing at the last step in the current trail
    // A trail might have more than one connection
    const currentTrail = trailsList[state.getIn(['tour', 'trails', 'current'])]
    const currentPointIndex = state.getIn(['tour', 'points', 'current'])
    let connections = []
    if (currentPointIndex == currentTrail.points.length - 1) {
        connections = currentTrail.connections.reduce((connections, connection) => {
            const trail = trails[connection.destTrailid]
            if (trail) {
                return [...connections, pointsCache[trail.id][0]]
            } else {
                return connections
            }
        }, [])
    }

    // Extract the media objects from the next 3 steps
    let mediaToCache = next3.concat(connections).map(point => {
        return internalGetMainMedia({
            stop: stops[point.stopid],
            point,
            orientation: FRONT,
            canDeriveMediaFromStops: canDeriveMediaFromStops(state),
            mainMedia: true,
        })
    })

    // Add the next stop media to the cache list
    if (currentStopIndex !== stopsList.length - 1) {
        let nextStop = stopsList.get(currentStopIndex + 1)
        let nextStopMedia = internalGetMainMedia({
            stop: nextStop,
            point: null,
            orientation: FRONT,
            canDeriveMediaFromStops: canDeriveMediaFromStops(state),
            mainMedia: true,
        })
        if (nextStopMedia !== null) {
            mediaToCache.push(nextStopMedia)
        }
    }

    //Cache media
    cacheNextMedia({
        currentPanoramaParams,
        media: mediaToCache,
    })
}

export const cacheNextMedia = ({ media, currentPanoramaParams }) => {
    const panoSize = currentPanoramaParams.get('size')
    const panoType = currentPanoramaParams.get('panoType')
    const maxPanosToCache = 2
    //Only cache the full image for the current and next pano
    let nextPanoCached = 0
    //Make sure we cache all the files at the same time to load the smallest files first
    let sources = [],
        thumbUrls = []

    media.forEach(({ mediaType, path, urls, id }) => {
        switch (mediaType) {
            case MEDIA_TYPES.panorama:
                if (panoType == undefined) {
                    return
                }
                // TODO: Ask PanoPlayer if pano type supports loading lower quality pano before hi
                // If not then there is no need to load the 512 image
                let thumbUrl = PanoPlayer.getTileUrl(path, panoType, 512)
                thumbUrls.push({ mediaType, src: thumbUrl })

                if (nextPanoCached < maxPanosToCache && panoSize !== undefined) {
                    let panoUrls = PanoPlayer.getTileUrl(path, panoType, panoSize)
                    if (Array.isArray(panoUrls)) {
                        panoUrls.forEach(elm => {
                            sources.push({ mediaType, src: elm })
                        })
                    } else {
                        sources.push({ mediaType, src: panoUrls })
                    }
                    nextPanoCached++
                }
                break
            default:
                sources.push({
                    mediaType,
                    src: urls.large,
                    path: path,
                })
        }
    })
    //Cache file images
    const cacheSrcs = thumbUrls.concat(sources)
    cacheSrcs.forEach(({ mediaType, src, path }) => {
        if (!CACHE[src]) {
            switch (mediaType) {
                case MEDIA_TYPES.photo:
                    WTPhotoController.loadPhoto(null, path, true)
                    break
                default:
                    const image = new Image()
                    image.crossOrigin = 'anonymous'
                    image.src = src
                    break
            }
            CACHE[src] = true
        }
    })
}
